<template>
  <v-app>
    <v-overlay :value="activeLoading">
      <span>{{ loadingPageMsg }}</span>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-content>
      <div
        v-if="
          $route.name === 'landingPage' ||
            $route.name === 'faq' ||
            $route.name == 'login' ||
            $route.name == 'register' ||
            $route.name == 'ADP' ||
            $route.name == 'ResetPassEmail' ||
            $route.name == 'ResetChangeEmail' ||
            $route.name == 'ResetPass' ||
            $route.name == 'ResetEmail' ||
            $route.name == 'veterinarias'
        "
      >
        <Nav />
      </div>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import Nav from "../src/components/MainNav";
import { mapState } from "vuex";

export default {
  name: "App",
  components: {
    Nav,
  },
  computed: {
    ...mapState(["activeLoading", "loadingPageMsg"]),
  },
};
</script>
